import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    display: "flex",
    marginBottom: theme.spacing(4),
  },
  spanCardMediaLeft: {
    paddingRight: theme.spacing(2),
  },
  spanCardMediaRight: {
    color: theme.palette.primary.main,
  },
}));

export function TextoEntrar() {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.logoContainer}>
      <Typography variant={"h4"} className={classes.spanCardMediaLeft}>
        {intl.formatMessage({ id: "ra.auth.entrar_en" })}
      </Typography>
      <Typography variant={"h4"} className={classes.spanCardMediaRight}>
        {document.title}
      </Typography>
    </div>
  );
}
